import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'

export const getScrollTriggerOptions = (
  node: HTMLElement,
  reverse: boolean,
  start = 'top 82%' // 'top 92%'
) => {
  return {
    scrollTrigger: {
      trigger: node,
      once: !reverse,
      start,
      markers: false,
      toggleActions: `play none none ${reverse ? 'reverse' : 'none'}`
    }
  }
}

export const opacityRevealAnimation = (target: gsap.DOMTarget) => {
  return gsap
    .timeline()
    .fromTo(target, { opacity: 0 }, { opacity: 1, duration: 1.2, ease: 'power2.out' })
}

export const batchOpacityRevealAnimation = ({
  targets,
  reverse,
  stagger,
  delay
}: {
  targets: gsap.DOMTarget
  reverse: boolean
  stagger?: gsap.NumberValue | gsap.StaggerVars
  delay?: number
}) => {
  gsap.set(targets, { opacity: 0 })

  return ScrollTrigger.batch(targets, {
    // interval: 0.1, // time window (in seconds) for batching to occur.
    // batchMax: 3,   // maximum batch size (targets)
    once: !reverse,
    start: 'top 82%',
    onEnter: (batch) =>
      gsap.to(batch, {
        opacity: 1,
        duration: 1.2,
        ease: 'power2.out',
        stagger,
        delay
      })
  })
}

export const batchScaleXRevealAnimation = ({
  targets,
  reverse,
  stagger,
  delay
}: {
  targets: gsap.DOMTarget
  reverse: boolean
  stagger?: gsap.NumberValue | gsap.StaggerVars
  delay?: number
}) => {
  gsap.set(targets, { scaleX: 0 })

  return ScrollTrigger.batch(targets, {
    // interval: 0.1, // time window (in seconds) for batching to occur.
    // batchMax: 3,   // maximum batch size (targets)
    once: !reverse,
    start: 'top 82%',
    onEnter: (batch) =>
      gsap.to(batch, {
        scaleX: 1,
        duration: 1,
        ease: 'power2.out',
        stagger,
        delay
      })
  })
}
